// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","538":"component---src-templates-fullscreen-js","740":"component---src-templates-docs-js"}[chunkId] + "-" + {"532":"24c404e606660b0b14d8","538":"451e2c2c557bbe78e34d","740":"e52a5a117085a0071020"}[chunkId] + ".js";
};